import { render, staticRenderFns } from "./QuotePage.vue?vue&type=template&id=33038720&scoped=true&"
import script from "./QuotePage.vue?vue&type=script&lang=js&"
export * from "./QuotePage.vue?vue&type=script&lang=js&"
import style0 from "./QuotePage.vue?vue&type=style&index=0&id=33038720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33038720",
  null
  
)

export default component.exports